import { Capacitor } from '@capacitor/core';

const app = 'firm';
const environment =
  import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE || 'local';
const platform = Capacitor.getPlatform();

/**
 * Type-safe application config
 */
export const config = {
  app,
  environment,
  platform,
  appIdentifier: `${app}-${environment}-${platform}`,
  version: __APP_VERSION__ || '-',
  api: {
    url: import.meta.env.VITE_API_URL || 'https://api.lisciostaging.com',
  },
  auth: {
    // placeholder
  },
  webApp: {
    url: import.meta.env.VITE_WEB_APP_URL || 'https://m.lisciostaging.com',
  },
  legacyRedirect: {
    url: import.meta.env.VITE_FIRM_REDIRECT_URL,
  },
  launchDarkly: {
    clientId: import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_SIDE_ID || '',
    isEnabled: Boolean(import.meta.env.VITE_LAUNCH_DARKLY_CLIENT_SIDE_ID),
  },
  psPdfKit: {
    licenseKey: import.meta.env.VITE_PSPDFKIT_LICENSE_KEY,
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN || '',
    isEnabled: Boolean(import.meta.env.VITE_SENTRY_DSN),
  },
  scanbot: {
    isEnabled: platform !== 'android',
  },
  statusBar: {
    backgroundColor: '#434566',
  },
  posthog: {
    projectToken: import.meta.env.VITE_POSTHOG_KEY,
    host:
      import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    /** In production and staging, send only 10% of events to control cost (LISD-2217). */
    eventSampleRate:
      environment === 'production' || environment === 'staging' ? 0.1 : undefined,
  },
  oauth: {
    google: {
      url:
        import.meta.env.VITE_GOOGLE_OAUTH_URL ||
        'https://accounts.google.com/o/oauth2/v2/auth',
      clientId: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID || '',
      redirectUri: import.meta.env.VITE_GOOGLE_OAUTH_REDIRECT_URI || '',
      scope:
        import.meta.env.VITE_GOOGLE_OAUTH_SCOPE ||
        'https://www.googleapis.com/auth/userinfo.email',
    },
    outlook365: {
      url:
        import.meta.env.VITE_OUTLOOK_OAUTH_URL ||
        'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
      clientId: import.meta.env.VITE_OUTLOOK_OAUTH_CLIENT_ID || '',
      redirectUri: import.meta.env.VITE_OUTLOOK_OAUTH_REDIRECT_URI || '',
      scope:
        import.meta.env.VITE_OUTLOOK_OAUTH_SCOPE ||
        'openid profile email People.Read User.read',
    },
  },
  /** Third-party pickers used by Files "Export to DMS". */
  dmsPickers: {
    googleAppId: import.meta.env.VITE_GOOGLE_FILE_PICKER_APP_ID || '',
    microsoftClientId: import.meta.env.VITE_MICROSOFT_CLIENT_ID || '',
  },
  oauthSelfSignup: {
    google: {
      redirectUri:
        import.meta.env.VITE_GOOGLE_SELF_SIGNUP_OAUTH_REDIRECT_URI || '',
      scope:
        import.meta.env.VITE_GOOGLE_SELF_SIGNUP_OAUTH_SCOPE ||
        'openid email profile',
    },
    outlook365: {
      redirectUri:
        import.meta.env.VITE_OUTLOOK_SELF_SIGNUP_OAUTH_REDIRECT_URI || '',
      scope:
        import.meta.env.VITE_OUTLOOK_SELF_SIGNUP_OAUTH_SCOPE ||
        'openid profile email User.read',
    },
  },
  /**
   * Dev mode and debug config.
   * Not to be used in production envs!
   */
  dev: {
    /**
     * Default CPA custom_liscio_url to resolve in preview environments
     */
    defaultSiteCpa: import.meta.env.VITE_DEV_DEFAULT_SITE_CPA || '',
    /**
     * Disable native live updates for local native app development
     */
    disableNativeLiveUpdates: import.meta.env
      .VITE_DEV_DISABLE_NATIVE_LIVE_UPDATES,
  },
};
